module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('Header'), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": require("./images/banner.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bannerCon"
  }, [_c('div', {
    staticClass: "textCon"
  }, [_c('p', {
    staticClass: "bigText"
  }, [_vm._v(_vm._s(_vm.copyData.technology.bannerTitleOne))]), _vm._v(" "), _c('p', {
    staticClass: "bigText"
  }, [_vm._v(_vm._s(_vm.copyData.technology.bannerTitleTwo))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.bannerTitleThree))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.bannerTitleFour))])])])]), _vm._v(" "), _c('p', {
    staticClass: "breadcrumb"
  }, [_vm._v(_vm._s(_vm.copyData.technology.breadcrumb) + _vm._s(_vm.breadcrumb))]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [(_vm.windowWidth >= 800) ? _c('div', {
    staticClass: "leftCon"
  }, [_c('div', {
    staticClass: "titleCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.technologyTitleZH))]), _vm._v(" "), _c('p', {
    staticClass: "titleEN"
  }, [_vm._v(_vm._s(_vm.copyData.technology.technologyTitleEN))])]), _vm._v(" "), _c('div', {
    staticClass: "menuCon"
  }, [_c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 1 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 1, _vm.breadcrumb = _vm.copyData.technology.advantage, _vm.getPosition()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/arrow.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.advantage))])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 2 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 2, _vm.breadcrumb = _vm.copyData.technology.produce, _vm.getPosition()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/arrow.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.produce))])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 3 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 3, _vm.breadcrumb = _vm.copyData.technology.detect, _vm.getPosition()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/arrow.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.detect))])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 4 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 4, _vm.breadcrumb = _vm.copyData.technology.environment, _vm.getPosition()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/arrow.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environment))])]), _vm._v(" "), _c('div', {
    staticClass: "phoneCon"
  }, [_c('img', {
    attrs: {
      "src": require("./images/phone.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.phoneTitle))]), _vm._v(" "), _c('p', {
    staticClass: "phoneNum"
  }, [_vm._v(_vm._s(_vm.copyData.technology.phoneNum))])])])]) : _vm._e(), _vm._v(" "), (_vm.windowWidth < 800) ? _c('div', {
    staticClass: "leftCon"
  }, [_c('div', {
    staticClass: "menuCon"
  }, [_c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 1 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 1, _vm.breadcrumb = _vm.copyData.technology.advantage
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.advantage))])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 2 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 2, _vm.breadcrumb = _vm.copyData.technology.produce
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.produce))])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 3 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 3, _vm.breadcrumb = _vm.copyData.technology.detect
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.detect))])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 4 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 4, _vm.breadcrumb = _vm.copyData.about.team
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.environment))])])])]) : _vm._e(), _vm._v(" "), (_vm.tabTag == 1 && _vm.windowWidth >= 800) ? _c('div', {
    staticClass: "rightConOne"
  }, [_c('div', {
    staticClass: "rightTop"
  }, [_c('div', {
    staticClass: "titleCon"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "titleZH"
  }, [_vm._v(_vm._s(_vm.copyData.technology.advantageTitleZH))]), _vm._v(" "), _c('p', {
    staticClass: "titleEN"
  }, [_vm._v(_vm._s(_vm.copyData.technology.advantageTitleEN))])])]), _vm._v(" "), _c('div', {
    staticClass: "rightMain"
  }, [_c('p', {
    staticClass: "mainTitle"
  }, [_vm._v(_vm._s(_vm.copyData.technology.advantageMainTitleOne))]), _vm._v(" "), _c('div', {
    staticClass: "infoList listOne"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon01.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTitleOne))])]), _vm._v(" "), _c('p', {
    staticClass: "listText"
  }, [_vm._v(_vm._s(_vm.copyData.technology.listTextOne))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listOne"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon02.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTitleTwo))])]), _vm._v(" "), _c('p', {
    staticClass: "listText"
  }, [_vm._v(_vm._s(_vm.copyData.technology.listTextTwo))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listOne"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon03.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTitleThree))])]), _vm._v(" "), _c('p', {
    staticClass: "listText"
  }, [_vm._v(_vm._s(_vm.copyData.technology.listTextThree))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listTwo"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon04.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleFour)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listText"
  }, [_vm._v(_vm._s(_vm.copyData.technology.listTextFour))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listTwo"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon05.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTitleFive))])]), _vm._v(" "), _c('p', {
    staticClass: "listText"
  }, [_vm._v(_vm._s(_vm.copyData.technology.listTextFive))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listTwo"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon06.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleSix)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listText"
  }, [_vm._v(_vm._s(_vm.copyData.technology.listTextSix))])])]), _vm._v(" "), _c('div', {
    staticClass: "rightMain"
  }, [_c('p', {
    staticClass: "mainTitle"
  }, [_vm._v(_vm._s(_vm.copyData.technology.advantageMainTitleTwo))]), _vm._v(" "), _c('div', {
    staticClass: "infoList listSpecial"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon07.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleSeven)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoCon"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextSeven01) + "      " + _vm._s(_vm.copyData.technology.listTextSeven02))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextSeven07) + "\n            ")]), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextSeven03))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextSeven04))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextSeven05))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextSeven06))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listThree"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon08.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleEight01)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTitleEight02))])]), _vm._v(" "), _c('div', {
    staticClass: "infoCon"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextEight01))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextEight02))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextEight03))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listThree"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon09.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleNine01)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTitleNine02))])]), _vm._v(" "), _c('div', {
    staticClass: "infoCon"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextNine01))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextNine02))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextNine03))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextNine04))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listThree"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon10.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleTen01)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTitleTen02))])]), _vm._v(" "), _c('div', {
    staticClass: "infoCon"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTen01))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTen02))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTen03))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTen04))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFour"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon11.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleEle)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoCon"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextEle01))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextEle02))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextEle03))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextEle04))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFour"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon12.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleTwe)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoCon"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTwe01))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTwe02))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTwe03))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTwe04))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTwe05))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFour"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon13.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleThi)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoCon"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextThi01))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextThi02))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextThi03))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextThi04))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextThi05))])])])])]) : _vm._e(), _vm._v(" "), (_vm.tabTag == 1 && _vm.windowWidth < 800) ? _c('div', {
    staticClass: "rightConOne"
  }, [_c('div', {
    staticClass: "rightTop"
  }, [_c('div', {
    staticClass: "titleCon"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "titleZH"
  }, [_vm._v(_vm._s(_vm.copyData.technology.advantageTitleZH))]), _vm._v(" "), _c('p', {
    staticClass: "titleEN"
  }, [_vm._v(_vm._s(_vm.copyData.technology.advantageTitleEN))])])]), _vm._v(" "), _c('div', {
    staticClass: "rightMain"
  }, [_c('p', {
    staticClass: "mainTitle"
  }, [_vm._v(_vm._s(_vm.copyData.technology.advantageMainTitleOne))]), _vm._v(" "), _c('div', {
    staticClass: "infoList listOne"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon01.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTitleOne))])]), _vm._v(" "), _c('p', {
    staticClass: "listText"
  }, [_vm._v(_vm._s(_vm.copyData.technology.listTextOne))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listOne"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon02.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTitleTwo))])]), _vm._v(" "), _c('p', {
    staticClass: "listText"
  }, [_vm._v(_vm._s(_vm.copyData.technology.listTextTwo))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listTwo"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon03.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTitleThree))])]), _vm._v(" "), _c('p', {
    staticClass: "listText"
  }, [_vm._v(_vm._s(_vm.copyData.technology.listTextThree))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listTwo"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon04.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleFour)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listText"
  }, [_vm._v(_vm._s(_vm.copyData.technology.listTextFour))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listThree"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon05.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTitleFive))])]), _vm._v(" "), _c('p', {
    staticClass: "listText"
  }, [_vm._v(_vm._s(_vm.copyData.technology.listTextFive))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listThree"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon06.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleSix)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listText"
  }, [_vm._v(_vm._s(_vm.copyData.technology.listTextSix))])])]), _vm._v(" "), _c('div', {
    staticClass: "rightMain"
  }, [_c('p', {
    staticClass: "mainTitle"
  }, [_vm._v(_vm._s(_vm.copyData.technology.advantageMainTitleTwo))]), _vm._v(" "), _c('div', {
    staticClass: "infoList listSpecial"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon07.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleSeven)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoCon"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextSeven01))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextSeven02))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextSeven03))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextSeven04))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextSeven05))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextSeven06))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFive"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon08.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleEight01)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleEight02)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoCon"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextEight01))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextEight02))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextEight03))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFive"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon09.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleNine01)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTitleNine02))])]), _vm._v(" "), _c('div', {
    staticClass: "infoCon"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextNine01))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextNine02))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextNine03))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextNine04))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listSix"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon10.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleTen01)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTitleTen02))])]), _vm._v(" "), _c('div', {
    staticClass: "infoCon"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTen01))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTen02))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTen03))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTen04))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listSix"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon11.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleEle)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoCon"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextEle01))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextEle02))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextEle03))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextEle04))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listEleven"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon12.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleTwe)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoCon"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTwe01))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTwe02))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTwe03))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTwe04))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextTwe05))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listEleven"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon13.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.listTitleThi)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoCon"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextThi01))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextThi02))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextThi03))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextThi04))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.listTextThi05))])])])])]) : _vm._e(), _vm._v(" "), (_vm.tabTag == 2 && _vm.windowWidth >= 800) ? _c('div', {
    staticClass: "rightConTwo"
  }, [_c('div', {
    staticClass: "rightTop"
  }, [_c('div', {
    staticClass: "titleCon"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "titleZH"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceTitleZH))]), _vm._v(" "), _c('p', {
    staticClass: "titleEN"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceTitleEN))])])]), _vm._v(" "), _c('div', {
    staticClass: "rightMain"
  }, [_c('p', {
    staticClass: "mainTitle"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceMainTitleOne))]), _vm._v(" "), _c('div', {
    staticClass: "infoList listOne"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce01.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleOne))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTextOne))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listOne"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce02.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleTwo))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTextTwo))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listOne"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce03.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleThree))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTextThree))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listTwo"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce04.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleFour))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFour01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFour02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMain))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFour03) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMonth))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFour04) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listTwo"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce05.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleFive))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFive01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFive02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMain))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFive03) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMonth))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFive04) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listTwo"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce06.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.produceListTitleSix)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSix01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSix02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMain))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSix03) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMonth))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSix04) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listThree"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce07.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleSeven))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSeven01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSeven02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMonth))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSeven03) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listThree"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce08.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleEight))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextEight01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMonth))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextEight02) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listThree"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce09.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleNine))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextNine01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextNine02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMain))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextNine03) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMonth))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextNine04) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "rightMain"
  }, [_c('p', {
    staticClass: "mainTitle"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceMainTitleTwo))]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFour"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce10.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleTen))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n                " + _vm._s(_vm.copyData.technology.produceListTextTen01) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "text textSpecial"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n                " + _vm._s(_vm.copyData.technology.produceListTextTen02) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.produceListTextTen03)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFour"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce11.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleEleven))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n                " + _vm._s(_vm.copyData.technology.produceListTextEleven01) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "text textSpecial"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n                " + _vm._s(_vm.copyData.technology.produceListTextEleven02) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.produceListTextEleven03)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFour"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce12.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleTwelve))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n                " + _vm._s(_vm.copyData.technology.produceListTextTwelve01) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "text textSpecial"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))])]), _c('p', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.produceListTextTwelve02)
    }
  }), _vm._v(" "), _c('p')])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFour"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce13.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleThirteen))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextThirteen01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text textSpecial"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextThirteen02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.produceListTextThirteen03)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFour"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce14.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.produceListTitleFourteen)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFourteen01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text textSpecial"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFourteen02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.produceListTextFourteen03)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleDay))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFourteen04) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFour"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce15.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleFiveTeen))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFiveteen01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text textSpecial"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFiveteen02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.produceListTextFiveteen03)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleYear))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFiveteen04) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listOne"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce16.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.produceListTitleSixTeen)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSixteen01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSixteen02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleDay))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSixteen03) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listOne"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce17.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleSevenTeen))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSeventeen01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSeventeen02) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listOne"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce18.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleEightTeen))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextEightTeen01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextEightTeen02) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listSpecial"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce19.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleNineTeen))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextNineTeen01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text textSpecial"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextNineTeen02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextNineTeen03) + "\n            ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.tabTag == 2 && _vm.windowWidth < 800) ? _c('div', {
    staticClass: "rightConTwo"
  }, [_c('div', {
    staticClass: "rightTop"
  }, [_c('div', {
    staticClass: "titleCon"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "titleZH"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceTitleZH))]), _vm._v(" "), _c('p', {
    staticClass: "titleEN"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceTitleEN))])])]), _vm._v(" "), _c('div', {
    staticClass: "rightMain"
  }, [_c('p', {
    staticClass: "mainTitle"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceMainTitleOne))]), _vm._v(" "), _c('div', {
    staticClass: "infoList listOne"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce01.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleOne))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTextOne))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listOne"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce02.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleTwo))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTextTwo))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listTwo"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce03.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleThree))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTextThree))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listTwo"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce04.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleFour))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFour01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFour02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMain))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFour03) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMonth))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFour04) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listThree"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce05.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleFive))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFive01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFive02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMain))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFive03) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMonth))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFive04) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listThree"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce06.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleSix))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSix01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSix02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMain))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSix03) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMonth))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSix04) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFour"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce07.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleSeven))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSeven01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSeven02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMonth))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSeven03) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFour"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce08.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleEight))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextEight01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMonth))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextEight02) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFive"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce09.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleNine))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextNine01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextNine02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMain))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextNine03) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleMonth))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextNine04) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "rightMain"
  }, [_c('p', {
    staticClass: "mainTitle"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceMainTitleTwo))]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFive"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce10.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleTen))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n                " + _vm._s(_vm.copyData.technology.produceListTextTen01) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "text textSpecial"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n                " + _vm._s(_vm.copyData.technology.produceListTextTen02) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.produceListTextTen03)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFive"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce11.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleEleven))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n                " + _vm._s(_vm.copyData.technology.produceListTextEleven01) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "text textSpecial"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n                " + _vm._s(_vm.copyData.technology.produceListTextEleven02) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.produceListTextEleven03)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFive"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce12.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleTwelve))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n                " + _vm._s(_vm.copyData.technology.produceListTextTwelve01) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "text textSpecial"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))])]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.produceListTextTwelve02)
    }
  }), _vm._v(" "), _c('p')])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFive"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce13.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleThirteen))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextThirteen01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text textSpecial"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextThirteen02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.produceListTextThirteen03)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFive"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce14.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleFourteen))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFourteen01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text textSpecial"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFourteen02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.produceListTextFourteen03)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleDay))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFourteen04) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFive"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce15.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleFiveTeen))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFiveteen01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text textSpecial"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFiveteen02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.copyData.technology.produceListTextFiveteen03)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleYear))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextFiveteen04) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFive"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce16.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleSixTeen))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSixteen01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSixteen02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleDay))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSixteen03) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFive"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce17.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleSevenTeen))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSeventeen01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextSeventeen02) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFive"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce18.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleEightTeen))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextEightTeen01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextEightTeen02) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listFive"
  }, [_c('img', {
    attrs: {
      "src": require("./images/produce19.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.produceListTitleNineTeen))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextNineTeen01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text textSpecial"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.produceTitleSpecialty))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextNineTeen02) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n              " + _vm._s(_vm.copyData.technology.produceListTextNineTeen03) + "\n            ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.tabTag == 3) ? _c('div', {
    staticClass: "rightConThree"
  }, [_c('div', {
    staticClass: "rightTop"
  }, [_c('div', {
    staticClass: "titleCon"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "titleZH"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectTitleZH))]), _vm._v(" "), _c('p', {
    staticClass: "titleEN"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectTitleEN))])])]), _vm._v(" "), _c('div', {
    staticClass: "rightMain"
  }, [_c('p', {
    staticClass: "mainTitle"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectMainTitleOne))]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('img', {
    attrs: {
      "src": require("./images/detect01.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectTitleOne))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectBrand))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectBrandOne) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectTextOne))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('img', {
    attrs: {
      "src": require("./images/detect02.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectTitleTwo))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextTwo01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectBrand))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectBrandTwo) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectRange))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextTwo02) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('img', {
    attrs: {
      "src": require("./images/detect03.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectTitleThree))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextThree01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectBrand))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectBrandThree) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectRange))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextThree02) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('img', {
    attrs: {
      "src": require("./images/detect04.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectTitleFour))]), _vm._v(" "), _c('div', {
    staticClass: "line lineSpecial"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextFour01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectBrand))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectBrandFour) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectRange))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextFour02) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('img', {
    attrs: {
      "src": require("./images/detect05.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectTitleFive))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectBrand))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectBrandFive) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectTextFive))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('img', {
    attrs: {
      "src": require("./images/detect06.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectTitleSix))]), _vm._v(" "), _c('div', {
    staticClass: "line lineSpecial"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextSix01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectBrand))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectBrandSix) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectRange))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextSix02) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "rightMain"
  }, [_c('p', {
    staticClass: "mainTitle"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectMainTitleTwo))]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('img', {
    attrs: {
      "src": require("./images/detect07.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectTitleSeven))]), _vm._v(" "), _c('div', {
    staticClass: "line lineSpecial"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextSeven01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectBrand))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectBrandSeven) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectRange))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextSeven03) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('img', {
    attrs: {
      "src": require("./images/detect08.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectTitleEight))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextEight01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectBrand))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectBrandEight) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectRange))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextEight03) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('img', {
    attrs: {
      "src": require("./images/detect09.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectTitleNine))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextNine01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectBrand))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectBrandNine) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectRange))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextNine02) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('img', {
    attrs: {
      "src": require("./images/detect10.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectTitleTen))]), _vm._v(" "), _c('div', {
    staticClass: "line lineSpecial"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextTen01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectBrand))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectBrandTen) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectRange))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextTen03) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('img', {
    attrs: {
      "src": require("./images/detect11.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.technology.detectTitleEleven))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectNum))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextEleven01) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectBrand))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectBrandEleven) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.copyData.technology.detectRange))]), _vm._v("\n              " + _vm._s(_vm.copyData.technology.detectTextEleven02) + "\n            ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.tabTag == 4) ? _c('div', {
    staticClass: "rightConFour"
  }, [_c('div', {
    staticClass: "rightTop"
  }, [_c('div', {
    staticClass: "titleCon"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "titleZH"
  }, [_vm._v(_vm._s(_vm.copyData.technology.environmentTitleZH))]), _vm._v(" "), _c('p', {
    staticClass: "titleEN"
  }, [_vm._v(_vm._s(_vm.copyData.technology.environmentTitleEN))])])]), _vm._v(" "), _c('div', {
    staticClass: "rightMain"
  }, [_c('p', {
    staticClass: "mainTitle"
  }, [_vm._v(_vm._s(_vm.copyData.technology.environmentMainTitleOne))]), _vm._v(" "), _c('div', {
    staticClass: "infoList listOne",
    on: {
      "click": function($event) {
        _vm.imgIndex = 0
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env01.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 1
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env02.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 2
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env03.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 3
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env04.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 4
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env05.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 5
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env06.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 6
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env07.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "rightMain"
  }, [_c('p', {
    staticClass: "mainTitle"
  }, [_vm._v(_vm._s(_vm.copyData.technology.environmentMainTitleTwo))]), _vm._v(" "), _c('div', {
    staticClass: "infoList listTwo",
    on: {
      "click": function($event) {
        _vm.imgIndex = 10
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env11.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextOne))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listTwo",
    on: {
      "click": function($event) {
        _vm.imgIndex = 11
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env12.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextTwo))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 12
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env13.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextThree))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 13
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env14.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextFour))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 14
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env15.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextFive))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 7
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env08.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 8
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env09.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 9
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env10.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infoList listThree",
    on: {
      "click": function($event) {
        _vm.imgIndex = 15
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env16.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextSix))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 16
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env17.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextSeven))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 17
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env18.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextEight))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 18
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env19.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextNine))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 19
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env20.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextTen))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 20
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env21.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextEleven))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 21
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env22.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextTwelve))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 22
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env23.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextThirteen))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 23
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env24.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextFourteen))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": function($event) {
        _vm.imgIndex = 24
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env25.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextFifteen))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listTwo",
    on: {
      "click": function($event) {
        _vm.imgIndex = 25
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env26.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextSixteen))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList listTwo",
    on: {
      "click": function($event) {
        _vm.imgIndex = 26
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/env27.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.technology.environmentTextSeventeen))])])]), _vm._v(" "), (_vm.flase) ? _c('div', {
    staticClass: "popCon",
    on: {
      "click": function($event) {
        _vm.imgIndex = -1
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgList[_vm.imgIndex].url,
      "alt": ""
    }
  })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('Footer'), _vm._v(" "), _c('div', {
    staticClass: "scroll-top",
    on: {
      "click": _vm.backToTop
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/backTop.png")
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e1d16784!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/technology/App.vue
// module id = 603
// module chunks = 4